import { objectTypes } from "src/consts/objectTypes";
import { ListInspections } from "src/components/ListInspections.js";

export function ListDeviations() {
  return <ListInspections objectType={objectTypes.Deviation} />;
}
